import React, { useState, useEffect } from 'react'
import { Form, Upload, Result, Button } from 'antd'
import { InboxOutlined } from '@ant-design/icons'
import { csv } from 'csvtojson'
import { func } from 'prop-types'

import { camelize, normalize } from '@utils/textUtils'
import { useCreateProvider } from '@graphql/mutations'

const options = {
  trim: true,
  ignoreEmpty: true,
}

function ManageProviderCsvUpload({ afterSubmit }) {
  const [data, setData] = useState()
  const [uploadComplete, setUploadComplete] = useState(false)
  const [createProvider, { loading }] = useCreateProvider()

  const normFile = e => {
    if (Array.isArray(e)) return e

    return e && e.fileList
  }

  useEffect(() => {
    const createAllProviders = data => {
      data.map(async d => {
        const { nome } = d

        await createProvider({
          variables: {
            data: {
              name: nome,
            },
          },
          refetchQueries: ['GetProvidersQuery'],
        })
      })

      setUploadComplete(true)
    }

    if (data) createAllProviders(data)
  }, [data, createProvider])

  const handleUpload = () => {}
  const props = {
    accept: `.txt, .csv, .xlsx`,
    name: `files`,
    beforeUpload: file => {
      const reader = new FileReader()

      reader.onload = e => {
        // const parsed = Papa.parse(e.target.result)

        csv(options)
          .fromString(e.target.result)
          .preFileLine((fileLineString, lineIdx) => {
            if (lineIdx === 0) {
              return normalize(
                camelize(fileLineString.toLowerCase()),
              )
            }

            return fileLineString
          })
          .then(data => setData(data))
      }

      reader.readAsText(file)

      return false
    },
  }

  if (uploadComplete) {
    return (
      <Result
        status="success"
        title="Fornecedores importados"
        subTitle="Pode fechar esta caixa."
        extra={[
          <Button type="primary" key="close" onClick={() => afterSubmit()}>
            Fechar
          </Button>,
        ]}
      />
    )
  }

  return (
    <Form onFinish={handleUpload}>
      <Form.Item>
        {!loading ? (
          <Form.Item name="dragger" valuePropName="fileList" getValueFromEvent={normFile} noStyle>
            <Upload.Dragger {...props}>
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">
                Clique ou arraste uma ficheiro para efectuar o upload.
              </p>
            </Upload.Dragger>
          </Form.Item>
        ) : `Loading ...`}
      </Form.Item>
    </Form>
  )
}

ManageProviderCsvUpload.propTypes = {
  afterSubmit: func.isRequired,
}

export default ManageProviderCsvUpload
